import GShell from './GShell.jsx'
import GProShopHome from './GProShopHome.jsx'

// Top-level admin page for the G-Features area — now the home of the Pro Shop
// Suite. Renders the standard admin chrome + access-code gate (via GShell),
// then the suite home (module grid). The legacy Golf-Genius sandbox is
// preserved inside GProShopHome. Reached from the sidebar (/admin/gg).
export default function GGPage() {
  return (
    <GShell>
      <GProShopHome />
    </GShell>
  )
}
